import LevelService from "../../services/datamaster/level.service";

export const Level = {
    data() {
      return {
        loadingMultiSelect : {
          isLoadingLevel : true,
        },
        loading: true,
        optionMasterLevel : [],
        multi_master_level : [],
        items_master_level : [],
        tipe_halaman : 'default',
        level: {},
      };
    },
    methods: {
      getAllLevel() {
        this.loading = true;
        LevelService.getLevel(0,1000000,'default')
          .then(response => {
              this.optionMasterLevel = response.data.data.content
              
              if(this.tipe_halaman == "all_data") {
                var data = {
                  idLevelAnggota: "default",
                  namaLevel: "Semua Data"
                }
                
                this.optionMasterLevel.unshift(data);
              }
              
              this.loadingMultiSelect.isLoadingLevel = false
              this.items_master_level = response.data.data.content;
              this.level = this.items_master_level[0]
              this.loading = false;
          }).catch(error => {
              // comment console console.log(error)
          })
      }
    }
  };